import { render, staticRenderFns } from "./ScenarioArea.vue?vue&type=template&id=8505fda0"
import script from "./ScenarioArea.vue?vue&type=script&lang=js"
export * from "./ScenarioArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports